/*
 * File per la definizione dei Service Angular, ovvero oggetti che espongono funzionalita' condivise tra diversi Controller:
 * https://code.angularjs.org/1.5.8/docs/guide/services
 */
define([
	'angular'
],
function(angular) {
	var shareParamsServices = angular.module('shareParamsServices', []);
	
	shareParamsServices.factory('ShareParamsService', ['$log', '$window', ShareParamsService]);

    /*
	 * Service che definisce i metodi che effettuano chiamate AJAX
     */
	function ShareParamsService($log, $window) {
		var jsonResponse = {}; 
        
//		setData: function(val) {
//		      $window.localStorage && $window.localStorage.setItem('my-storage', val);
//		      return this;
//		    },
//		    getData: function() {
//		      return $window.localStorage && $window.localStorage.getItem('my-storage');
//		    }
		
		return {
			setJsonResponse: setJsonResponse,
		    getJsonResponse: getJsonResponse,
		    removeJsonResponse: removeJsonResponse
		  };

		  function setJsonResponse (datiResponse) {
			  //jsonResponse = datiResponse;
			  $window.sessionStorage && $window.sessionStorage.setItem('bean', JSON.stringify(datiResponse));
	      };
	      function getJsonResponse() {
	    	  return $window.sessionStorage && JSON.parse(window.sessionStorage.getItem('bean'));
	      };
	      function removeJsonResponse() {
	    	  $window.sessionStorage.removeItem('bean');
	      };
    }

	return shareParamsServices;	
});


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/services/share-params-services.js
// module id = 46
// module chunks = 1